// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "e5034a5a0c0e9a0bd384" + ".chunk.js";
};